import { Component, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';

import { CommonJS } from 'angular-library';

import { Dirette, EventiDirette } from '../shared/shared.module';

@Component({
    moduleId: module.id,
    selector: 'cronaca',
    templateUrl: 'cronaca.html'
})
export class CronacaComponent implements OnChanges {

    @Input() diretta: Dirette = null;
    @Input() onlyMainEvents: boolean = false;
    @Output() onSwitchEvents = new EventEmitter();
    eventiDiretta: EventiDirette[] = new Array<EventiDirette>();
    eventi: EventiDirette[] = new Array<EventiDirette>();
    cellulare: boolean = false;

    ngOnChanges(changes: SimpleChanges): void {
        this.cellulare = CommonJS.getDisplayWidth() <= 480;
        if (changes["diretta"]) {
            this.eventiDiretta = this.diretta.eventiDiretta;
            if (this.eventiDiretta) {
                this.eventiDiretta.sort((a, b) => {
                    if (a.stato_diretta < b.stato_diretta) return 1;
                    if (a.stato_diretta > b.stato_diretta) return -1;
                    if (a.minuto < b.minuto) return 1;
                    if (a.minuto > b.minuto) return -1;
                    if (a.extra_time < b.extra_time) return 1;
                    if (a.extra_time > b.extra_time) return -1;
                    if (a.last_modified < b.last_modified) return 1;
                    if (a.last_modified > b.last_modified) return -1;
                });
                this.toggleEventi(this.onlyMainEvents);
            }
        }
    }

    switchEvents(main: boolean) {
        this.onSwitchEvents.emit(main);
    }

    toggleEventi(main: boolean) {
        if (this.onlyMainEvents && this.eventiDiretta) this.eventi = this.eventiDiretta.filter(x => x.main_event);
        else this.eventi = this.eventiDiretta;
    }

    showTime(evento: EventiDirette): boolean {
        return evento.minuto > -1 && evento.minuto < 9999 && evento.stato_diretta != 10 && evento.id_evento >= 0;
    }

    minutaggio(evento: EventiDirette): string {
        if(evento.stato_diretta == 11 && this.diretta.marcatureMatch.filter(x => x.rigoriDts).length > 0) return 'd.t.s.';
        else return evento.minuto.toString() + "'";
    }
}


// WEBPACK FOOTER //
// ./src/app/cronaca/cronaca.component.ts